import type { ToastInput, ToastType } from '../types/toast';

type ToastDispatchFn = (
  type: ToastType,
  input: ToastInput,
) => string | undefined;

let dispatchToast: ToastDispatchFn | null = null;

export function registerToastDispatch(fn: ToastDispatchFn | null) {
  dispatchToast = fn;
}

export function invokeToastDispatch(
  type: ToastType,
  input: ToastInput,
): string | undefined {
  return dispatchToast?.(type, input);
}
